import { render, staticRenderFns } from "./ProfilePicture.vue?vue&type=template&id=4a9ec4e5&scoped=true&"
import script from "./ProfilePicture.vue?vue&type=script&lang=js&"
export * from "./ProfilePicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ec4e5",
  null
  
)

export default component.exports